angular.module('gc.profile-popin', ['gc.user'])
.controller("ProfilePopinController", [
'$rootScope',
'$scope',
'$log',
'$location',
'$element',
'$timeout',
'$translate',
'GcUser',
'CommentService',
'Utils',
'BASE_URL',
'APP_LANGUAGES',
function ($rootScope, $scope, $log, $location, $element, $timeout, $translate, GcUser, CommentService, Utils, BASE_URL, APP_LANGUAGES) {
  'use strict';

  $scope.Utils = Utils;
  $scope.progress = 0;
  $scope.BASE_URL = BASE_URL;
  $scope.customImage = CommentService.getCustomImage();
  $scope.websitePrivateComments = CommentService.website.graphcomment.profile_private_comments;
  $scope.defaultAvatars = GcUser.getDefaultAvatars();
  $scope.open = { defaultAvatars: false };
  $scope.grades = {
    owner: $rootScope.website.labels && $rootScope.website.labels.owner || $translate.instant('owner'),
    moderator: $rootScope.website.labels && $rootScope.website.labels.moderator || $translate.instant('moderator'),
  };

  CommentService.getUserCount($scope.userId).success(function(data) {
    $scope.count_comment = data.count;
  });

  $scope.activeTab = $scope.tab || 'badges';

  CommentService.waitForWebsite(function(website) {
    if (!website.rewards && $scope.activeTab === 'badges') $scope.activeTab = 'comments';
  });

  $scope.switchTab = function(tab) {
    $scope.activeTab = tab;
  };

  $scope.allRewards = [
    { name: 'commentator', type: 'copper' },
    { name: 'optimistic', type: 'copper' },
    { name: 'spark', type: 'copper' },
    { name: 'firefighter', type: 'copper' },
    { name: 'influencer', type: 'copper' },
    { name: 'citizen', type: 'copper' },
    { name: 'supporter', type: 'copper' },
    { name: 'selfier', type: 'copper' },
    { name: 'autobiographer', type: 'copper' },
    { name: 'deputy', type: 'silver' },
    { name: 'civic', type: 'silver' },
    { name: 'guest star', type: 'silver' },
    { name: 'epic', type: 'silver' },
    { name: 'lobbyist', type: 'silver' },
    { name: 'rasputin', type: 'gold' },
    { name: 'detractor', type: 'gold' },
    { name: 'marshall', type: 'gold' },
    { name: 'legendary', type: 'gold' },
  ];

  $scope.seeFullProfile = function(tab) {
    mixpanel.track('profile:see-complete-profile');

    document.body.classList.add('no-scroll');

    $scope.showFullProfile = true;
    
    if(!$scope.profile.private_comments || !$scope.websitePrivateComments){
      $scope.loadComments(1, true);
    }
      
    if (tab) $scope.switchTab(tab);

    $timeout(function() {
      var bodyMargin = parseInt(getComputedStyle(document.querySelector('.gc-body'))['padding-left'], 10);
      var pos = $element[0].querySelector('.gc-popin').getBoundingClientRect();
      $scope.offset = {
        left: !$rootScope.rtl && '50%',
        right: $rootScope.rtl && '50%',
        top: (Utils.inIframe() && (!Utils.inOverlay() || Utils.isMobile())) ? $scope.offset.top : '20px'
      };
    }, 0);
  };

  $scope.loadComments = function(page, disableScrollTo) {
    var isMobile = window.innerWidth < 500;
    

      CommentService.getUserComments(
        $scope.profile._id,
        page,
        $scope.sorting
      ).success(function(comments) {
        $scope.comments = comments;
        $scope.commentsPage = page;
        $scope.nbPage = isMobile ? 3 : 10;
        $scope.commentsPageCount = Math.ceil($scope.count_comment / $scope.nbPage);

      

        var paginationStart = Math.max(1, page - Math.floor(($scope.nbPage - 1) / 2));
        $scope.commentsPageRange = _.range(
          paginationStart,
          Math.min($scope.commentsPageCount + 1, $scope.nbPage + paginationStart)
        );

        !disableScrollTo && $timeout(function() {
          var scrollContainer = document.querySelector('.gc-popin-wrapper.gc-popin-profile');
          $rootScope.$emit('scrollTo', '.gc-profile-tabs', scrollContainer);
        }, 100);
      });

  };

  $scope.onOverlayClick = function(event) {
    if ($scope.profile.profile_found && event && event.target.classList.contains('gc-popin-profile')) {
      $scope.close();
    }
  };

  $scope.shouldFillProfile = function() {
    return $scope.profile && $scope.isCurrentUser && !$scope.profile.profile_found;
  };

  $scope.open = function () {

    if (!$scope.userId) {
      mixpanel.track('profile:open_guest');
      return;
    }

    mixpanel.track('profile:open');

    GcUser.canSendRecoTo($scope.userId).success(function(resp) {
      $scope.canSendRecoTo = resp;
    });

    if ($scope.fullProfile) {
      $scope.showFullProfile = true;
    }

    return CommentService.getUserObject($scope.userId).then(function (resp) {
      
      var data = resp.data;
      if(!data.user ){
        $scope.close();
        GcUser.logout();
        return;
      }
        
      if (GcUser.getUser() && GcUser.getUser()._id === $scope.userId) {
        angular.extend(data.user, GcUser.getUser());
      }
 
      $scope.profile = data.user;
      $scope.profile.pseudo = $scope.profile.profile_found ? $scope.profile.pseudo : '';
      $scope.isCurrentUser = GcUser.getUser() && $scope.profile._id === GcUser.getUser()._id;
      $scope.stats = data.stats;

     

      // fix angular bug
      // sometimes the 'is-loading' class is not well removed
      $timeout(function() {
        $element.find('.gc-popin').removeClass('is-loading');
      }, 0);

      $scope.updateProgress();

      if (typeof $scope.profile.loading_depth === 'undefined') {
        $scope.profile.loading_depth = -1;
      }

      if (CommentService.website.rewards) {
        var rewards = sortRewards(data.rewards);
        $scope.rewards = $scope.allRewards.map(reward => {
          return _.extend({}, reward, {
            possess: !!rewards.find(r => r.name === reward.name),
          });
        });
        $scope.groupedRewards = groupRewards(data.rewards);
      }
      
    });
  };

  function sortRewards(rewards) {
    return _.sortBy(rewards, r => r.type === 'silver' ? 0 : (r.type === 'gold' ? -1 : 1));
  }

  function groupRewards(rewards) {
    rewards = _.groupBy(rewards, 'type');
    // show 0 if no reward
    ['gold', 'silver', 'copper'].forEach(type => {
      if (!rewards[type]) rewards[type] = [];
    });
    // sort by type
    return {
      gold: rewards.gold,
      silver: rewards.silver,
      copper: rewards.copper,
    };
  };

  $scope.selectAvatar = function (avatar) {
    $scope.previewAvatarSrc = null;
    $scope.profile.picture = avatar.url;
    $scope.open.defaultAvatars = false;
    $scope.updateProfile();
  };

  // preview avatar
  $scope.onAvatarUpload = function(event) {
    var files = event.target.files;
    if (files && files.length) {
      var reader = new FileReader();
      reader.onload = function(e) {
        $scope.previewAvatarSrc = e.target.result;
        $scope.$apply();
      };
      if (files[0].type.match('image.*')) {
        reader.readAsDataURL(files[0]);
      }
      $scope.updateProfile();
    }
  };

  $scope.updateProfile = function () {
    if($scope.profile.pseudo === '' && !$scope.profile.profile_found) return;
    $scope.err = null;

    if ($scope.profile.twitter_username && $scope.profile.twitter_username[0] !== '@') {
      $scope.profile.twitter_username = '@' + $scope.profile.twitter_username;
    }

    if ($scope.profile.bio) {
      $scope.profile.bio = $scope.profile.bio.trim();

      if ($scope.profile.bio.match(/^(<br \/>)+$/)) {
        $scope.profile.bio = '';
      }
    }

    var userData = angular.extend({}, $scope.profile, { picture: $scope.profile.$picture || $scope.profile.picture });
    userData.website = CommentService.website._id;

    return GcUser.update(userData, function(err, profile) {
      if (err) {
        $scope.err = err;
        return;
      }

      $scope.editBio = false;
      $scope.profile = angular.extend($scope.profile, profile);
      $scope.open.defaultAvatars = false;

      // reset upload
      $scope.profile.$picture = null;
      $scope.previewAvatarSrc = null;
      $scope.uploadProgress = null;

      mixpanel.track('profile:updated');

      $scope.updateProgress();
    }, function (uploadProgress) {
      if ($scope.profile.$picture) {
        $scope.uploadProgress = uploadProgress;
      }
    });
  };

  $scope.createProfile = function () {
    if($scope.profile.pseudo === '' && !$scope.profile.profile_found){
      $scope.err =  $translate.instant('please enter a username');
      return;
    }
  
    $scope.updateProfile().success(function() {
      $scope.profile.profile_found = true;
      $scope.close();
    });
  };

  $scope.displayTwitterUsername = function() {
    if (!$scope.profile.twitter_username) return '';

    return $scope.profile.twitter_username[0] === '@'
      ? $scope.profile.twitter_username
      : '@' + $scope.profile.twitter_username
    ;
  };

  $scope.sendReco = function() {
    mixpanel.track('profile:recommendation', { from: GcUser.getUser().pseudo, to: $scope.profile.pseudo });
    GcUser.sendRecoTo($scope.userId).success(function() {
      $scope.canSendRecoTo = false;
    });
  };

  $scope.profileFetched = function() {
    return !!$scope.profile;
  };

  $scope.canEditInline = function(field) {
    if ($rootScope.ssoUnidirectionalEnabled()) {
      if (field !== 'pro_status' && field !== 'bio' && field !== 'twitter_username') return false;
    }
    if ($rootScope.isOrange && $scope.hasModerationWaiting()) return false;
    return $scope.isCurrentUser;
  };

  $scope.toggleBio = function(event) {
    event && event.preventDefault();

    // with a timeout else close() is called
    // because clicked element doesn't belong to the popin anymore
    $timeout(function() {
      $scope.editBio = !$scope.editBio;

      // put back initial bio when clicking 'cancel'
      if ($scope.editBio) {
        $scope.initialBio = $scope.profile.bio;

        // doesn't work, even with a setTimeout()
        //$element[0].querySelector('.profile-bio-form textarea').focus();
      } else {
        $scope.profile.bio = $scope.initialBio;
      }
    });
  };

  $scope.updateProgress = function() {
    var progress = 0;

    if ($scope.profile.pseudo !== '') {
      progress += 25;
    }
    if ($scope.profile.picture && $scope.profile.picture !== 'front/images/avatar_3.png') {
      progress += 25;
    }
    if ($scope.profile.bio) {
      progress += 25;
    }
    if ($scope.profile.pro_status) {
      progress += 25;
    }

    $scope.progress = progress;

    $timeout(function() {
      // for css transitions
      $element.find('.gc-profile-progress .progress').css('width', progress + '%');
    });
  };

  $scope.completeProgress = function() {
    if (!$scope.profile.pro_status) {
      $timeout(function() {
        $element.find('.profile-status a').click();
      });
    }
    else if (!$scope.profile.bio) {
      $timeout(function() {
        $element.find('.profile-bio').click();
      });
    }
    else if (!$scope.profile.picture || $scope.profile.picture === '/images/avatar_3.png') {
      $timeout(function() {
        $element.find('.upload-container').click();
      });
    }
  };

  $scope.sorting = 'date';

  $scope.showSortDropdown = function(event) {
    event.preventDefault();
    $scope.sortDropdownVisible = !$scope.sortDropdownVisible;
  };

  $scope.setSort = function(event, sorting) {
    event.stopPropagation();
    $scope.sorting = sorting;
    $scope.sortDropdownVisible = false;
    $scope.seeFullProfile();
  };

  $scope.deleteModal = function(event, comment) {
    event.preventDefault();

    var targetRect = event.target.getBoundingClientRect();
    var $popinScrollTop = document.querySelector('.gc-popin-profile').scrollTop;

    var $popin = document.querySelector('.gc-popin.profile-full');
    var popinTop = $popin.getBoundingClientRect().top;

    var popinY = targetRect.top + $popinScrollTop;
    if (Utils.inIframe()) popinY -= popinTop;

    if (popinY > 0) {
      $rootScope.deleteCommentPopinCoord = {
        y: popinY,
      };
    } else {
      $rootScope.deleteCommentPopinCoord = null;
    }

    $scope.showCommentDeletionPopin = true;
    $scope.commentToDelete = comment;
  };

  $scope.commentDeletionPopinOverlayClick = function(event) {
    event.stopPropagation(); // prevent profile-popin to close
    if (event.target.classList.contains('gc-popin-wrapper')) {
      $scope.hideDeletionPopin();
    }
  };

  $scope.hideDeletionPopin = function(event) {
    event && event.stopPropagation(); // prevent profile-popin to close
    $scope.showCommentDeletionPopin = false;
    $scope.commentToDelete = null;
  };

  $scope.deleteComment = function(comment) {
    var parent = comment.parent_id ? CommentService._comments[comment.parent_id] : null;
    CommentService.remove(comment, parent).success(function() {
      $scope.hideDeletionPopin();
    });
  };

  $scope.shareComment = function(event, comment) {
    $scope.showSharePopin = false;

    $timeout(function() {
      mixpanel.track('comment:share');
      $scope.showSharePopin = true;
      $scope.commentToShare = comment;
      $scope.commentToSharePlacement = event.target;
    });
  };

  $scope.isCommentStillAlive = function(comment) {
    var lifetime = CommentService.thread.lifetime;

    if (lifetime) {
      var threadDate = moment(comment.content_edited_at || comment.created_at);
      if (threadDate.isBefore(moment().subtract(lifetime, 'days'))) return false;
    }

    return true;
  };

  $scope.getThreadLink = function(comment) {
    if (!$scope.isCommentStillAlive(comment)) return '';
    return Utils.appendGetParam(comment.thread.url, 'comment_id=' + comment._id);
  }

  $scope.hasModerationWaiting = function() {
    if (!$rootScope.isOrange) return false;
    if (!GcUser.getUser() || GcUser.getUser()._id !== $scope.userId) return false;

    return (
      $scope.profile.pro_status_sended_moderation ||
      $scope.profile.twitter_username_sended_moderation
    );
  };


  // prefs
  // ------------------------

  // filter only languages enabled
  var langsEnabled = CommentService.website.languages;
  $scope.langs = APP_LANGUAGES.slice().filter(lang => {
    return langsEnabled.indexOf(lang.value) !== -1;
  });

  function syncProfile() {
    $scope.profile = angular.extend({}, GcUser.getUser());
    $scope.initialProfile = angular.copy($scope.profile);
  }

  syncProfile();

  // reload user data once verification done
  $rootScope.$on('user:change', syncProfile);

  $scope.updatePrefs = function () {

    if(!$scope.profile.profile_found && scope.profile.pseudo === '') return;
    $scope.err = null;

    var profileData = angular.extend({}, $scope.profile);
    profileData.website = CommentService.website._id;

    // update profile
    GcUser.update(profileData, function(err, profile) {
      if (err) {
        $scope.err = err;
        return;
      }
      if(!$scope.profile.private_comments) {
        $scope.loadComments(1, true);
      }

    });
  };

  $scope.$watch('profile', function() {
    $scope.profileChanged = JSON.stringify($scope.profile) !== JSON.stringify($scope.initialProfile);
  }, true);




  var unbindWatch;
  $scope.$watch('userId', function() {
    unbindWatch && unbindWatch();

    $scope.profile = null;

    // fix angular bug
    $element.find('.gc-popin').removeClass('is-loading');

    // with a timeout because 'close()' is called on body click
    // so we want to make sure 'open()' is always called after
    $timeout(function() {
      $scope.open();
      
    }, 0);

    unbindWatch = $scope.$watch('profile', function(newProfile, oldProfile) {
      if (!newProfile || !oldProfile || newProfile._id !== oldProfile._id) return;
      if (newProfile.pseudo !== oldProfile.pseudo) $scope.updateProfile();
      if (newProfile.pro_status !== oldProfile.pro_status) $scope.updateProfile();
      if (newProfile.twitter_username !== oldProfile.twitter_username) $scope.updateProfile();
    }, true);
  });

  $scope.open().then(function() {
    if ($scope.fullProfile) {
      $scope.seeFullProfile();
    }
  });

}])
.directive('profilePopin', ['$document', '$timeout', function ($document, $timeout) {
  'use strict';
  return {
    scope: {
      userId: '@',
      show: '@',
      closePopin: '&close',
      fromMenu: '@',
      editBio: '@',
      tab: '@',
      fullProfile: '@',
      offset: '=',
      profileFound: '='
    },
    controller: "ProfilePopinController",
    templateUrl: 'profilePopin.html',
    replace: true,
    restrict: 'E',
    link: function ($scope, el, attrs, controller) {
      $scope.close = $scope.closePopin();

      $timeout(function() {

        $document.on('click.gc-profile-popin', function(event) {
          if (!$scope.show) return
          if (el[0].contains(event.target)) return
          var $emailPopin = document.querySelector('.gc-popin--email');
          if ($emailPopin && $emailPopin.contains(event.target)) return
          var $emailPopin = document.querySelector('.gc-popin--email');
          $scope.close();
        });

        $document.on('keyup.gc-profile-popin', function(event) {
          if(!$scope.profileFound) return;
          if (event.keyCode === 27) { // ESC
            $scope.close();
          }
        });
  
      }, 0);

      $scope.$on('$destroy', function() {
        $document.off('click.gc-profile-popin');
        $document.off('keyup.gc-profile-popin');
        document.body.classList.remove('no-scroll');
      });
    }
  };
}]);

